import {t} from 'common/utils/translation-util';

export const NO_PERIOD_OPTION_LABEL = t('All time');
export const NO_PERIOD_OPTION_VALUE = 'noPeriod';
export const CUSTOM_OPTION_LABEL = t('Custom period');
export const CUSTOM_OPTION_VALUE = 'custom';
